// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__oxmsP","selected":"Tag_selected__ZIYQ4","thin":"Tag_thin__rTK2g"};